var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FileSave',_vm._b({attrs:{"icon":"mdi-plus","maxWidth":500,"setTitle":_vm.setTitle,"fileData":_vm.fileData},on:{"onFile":(response) => _vm.$emit('onFile', response)}},'FileSave',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }